var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35419 20.3301C8.05933 20.9524 8.98557 21.3301 10 21.3301C11.0145 21.3301 11.9407 20.9524 12.6458 20.3301M16 7.33008C16 5.73878 15.3679 4.21266 14.2427 3.08744C13.1174 1.96222 11.5913 1.33008 10 1.33008C8.40872 1.33008 6.8826 1.96222 5.75738 3.08744C4.63216 4.21266 4.00002 5.73878 4.00002 7.33008C4.00002 10.4203 3.22049 12.536 2.34968 13.9355C1.61515 15.116 1.24788 15.7062 1.26134 15.8708C1.27626 16.0532 1.31488 16.1227 1.46179 16.2317C1.59448 16.3301 2.19261 16.3301 3.38887 16.3301H16.6112C17.8074 16.3301 18.4056 16.3301 18.5382 16.2317C18.6852 16.1227 18.7238 16.0532 18.7387 15.8708C18.7522 15.7062 18.3849 15.116 17.6504 13.9355C16.7795 12.536 16 10.4203 16 7.33008Z",
    stroke: "#F4FBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.145ed1b804c5f694758b9f49b9fd176d.svg";
export { ForwardRef as ReactComponent };